export default __webpack_public_path__ + "0e34fc494c2c6966c3bee67cc5bc1eb2.png";